module.exports = __webpack_public_path__ + "img/115707a0-d689-11e8-828a-1334c9ae6ae8-image.42ac98c7.jpg";